export default "__VITE_PUBLIC_ASSET__e25a7be8__"